module.exports = __webpack_public_path__ + "static/img/yingyong1.720b33c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/yingyong1.png
// module id = D6DA
// module chunks = 5